export { default } from './ConsultationFormPrimary';
